import { Drawer, styled } from "@mui/material"

export const CustomDrawer = styled(Drawer)(
  ({ theme: { breakpoints } }) => `
  width: 100%;
  display:none;
  ${[breakpoints.down("md")]}{
    display:unset;

}
  & .MuiPaper-root{
  width: 15vw;

  ${[breakpoints.down("md")]}{
        width: 60vw;

  }
}
`
)

export const CustomContainer = styled("div")(
  ({ theme: { breakpoints } }) => `
  display:unset;
  ${[breakpoints.down("md")]}{
    display:none;
}
}
`
)
